import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const parametrizacaoDeclaracaoRoutes: Routes = [
  {
    path: 'parametrizacao-declaracao',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./parametrizacao-declaracao.component').then(m => m.ParametrizacaoDeclaracaoComponent),
        data: {
          title: 'Gerenciar texto da declaração',
          roles: [Role.PARAMETRO_DECLARACAO_CONSULTAR],
          breadcrumb: [{ label: 'Gerenciar texto da declaração', url: '/parametrizacao-declaracao' }],
        },
      },
      {
        path: 'cadastrar',
        loadComponent: () => import('./formulario/parametrizacao-declaracao-formulario.component').then(m => m.ParametrizacaoDeclaracaoFormularioComponent),
        data: {
          title: 'Cadastrar texto da declaração',
          roles: [Role.PARAMETRO_DECLARACAO_EDITAR],
          breadcrumb: [
            { label: 'Gerenciar texto da declaração', url: '/parametrizacao-declaracao' },
            { label: 'Cadastrar', url: '/parametrizacao-declaracao/cadastrar' },
          ],
        },
      },
      {
        path: 'editar/:id',
        loadComponent: () => import('./formulario/parametrizacao-declaracao-formulario.component').then(m => m.ParametrizacaoDeclaracaoFormularioComponent),
        data: {
          title: 'Editar texto da declaração',
          roles: [Role.PARAMETRO_DECLARACAO_EDITAR],
          breadcrumb: [
            { label: 'Gerenciar texto da declaração', url: '/parametrizacao-declaracao' },
            { label: 'Editar', url: '/parametrizacao-declaracao/editar' },
          ],
        },
      },
      {
        path: 'visualizar/:id',
        loadComponent: () => import('./formulario/parametrizacao-declaracao-formulario.component').then(m => m.ParametrizacaoDeclaracaoFormularioComponent),
        data: {
          title: 'Visualizar texto da declaração',
          roles: [Role.PARAMETRO_DECLARACAO_CONSULTAR],
          breadcrumb: [
            { label: 'Gerenciar texto da declaração', url: '/parametrizacao-declaracao' },
            { label: 'Visualizar', url: '/parametrizacao-declaracao/visualizar' },
          ],
        },
      },
    ],
  },
];
